import { render } from "./ConsultaUsuario.vue?vue&type=template&id=2d386183"
import script from "./ConsultaUsuario.vue?vue&type=script&lang=js"
export * from "./ConsultaUsuario.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__